"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _effects = require("redux-saga/effects");

var _action = require("../../../../../../components/notification/action");

var _action2 = require("../../../../../../components/spinner-overlay/action");

var _commonConstants = require("../../../../../../utils/common-constants");

var _externalization = require("../../../../externalization");

var _action3 = require("./action");

var _constants = require("./constants");

var _service = require("./service");

var _commonUtils = require("../../../../../../utils/common-utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getImmediateNodesWatcher),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(getImmediateNodesWorker);

var getVaultDetails = function getVaultDetails(state) {
  return state.vaultLanding.data;
};

function getImmediateNodesWatcher() {
  return regeneratorRuntime.wrap(function getImmediateNodesWatcher$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.takeLatest)(_constants.getImmediateNodesTypes.GET_IMMEDIATE_NODES_REQUEST, getImmediateNodesWorker);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function getImmediateNodesWorker(_ref) {
  var payload, _immediateNodes, _immediateNodes2, _immediateNodes3, _immediateNodes3$pagi, _immediateNodes4, _immediateNodes4$pagi, _yield$select, vaultId, allResult, pageToken, immediateNodes, immediateNodesPagination, _immediateNodes5$pagi, _immediateNodes5, _immediateNodes5$pagi2, _response$data, response, reason;

  return regeneratorRuntime.wrap(function getImmediateNodesWorker$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref.payload;
          _context2.prev = 1;
          _context2.next = 4;
          return (0, _effects.put)((0, _action3.loadingGetImmediateNodes)());

        case 4:
          _context2.next = 6;
          return (0, _effects.put)((0, _action2.initSpinnerOverlay)({
            open: true,
            size: 'medium',
            message: (0, _externalization.translate)('SECRETS_MODULE.LOADING_NODE_DATA')
          }));

        case 6:
          _context2.next = 8;
          return (0, _effects.select)(getVaultDetails);

        case 8:
          _yield$select = _context2.sent;
          vaultId = _yield$select.id;
          allResult = [];
          pageToken = '';
          _context2.next = 14;
          return (0, _effects.call)(_service.getImmediateNodes, payload, vaultId);

        case 14:
          immediateNodes = _context2.sent;
          allResult = _toConsumableArray((_immediateNodes = immediateNodes) === null || _immediateNodes === void 0 ? void 0 : _immediateNodes.result);
          immediateNodesPagination = (_immediateNodes2 = immediateNodes) === null || _immediateNodes2 === void 0 ? void 0 : _immediateNodes2.pagination;
          if ((_immediateNodes3 = immediateNodes) !== null && _immediateNodes3 !== void 0 && (_immediateNodes3$pagi = _immediateNodes3.pagination) !== null && _immediateNodes3$pagi !== void 0 && _immediateNodes3$pagi.next) pageToken = (0, _commonUtils.getQueryParamsFromUrl)((_immediateNodes4 = immediateNodes) === null || _immediateNodes4 === void 0 ? void 0 : (_immediateNodes4$pagi = _immediateNodes4.pagination) === null || _immediateNodes4$pagi === void 0 ? void 0 : _immediateNodes4$pagi.next, _commonConstants.PAGE_TOKEN);

        case 18:
          if (!pageToken) {
            _context2.next = 27;
            break;
          }

          _context2.next = 21;
          return (0, _effects.call)(_service.getImmediateNodes, _objectSpread(_objectSpread({}, payload), {}, {
            vaultId: vaultId,
            pageToken: pageToken
          }));

        case 21:
          _immediateNodes5 = _context2.sent;
          allResult = [].concat(_toConsumableArray(allResult), _toConsumableArray(_immediateNodes5 === null || _immediateNodes5 === void 0 ? void 0 : _immediateNodes5.result));
          immediateNodesPagination = _immediateNodes5 === null || _immediateNodes5 === void 0 ? void 0 : _immediateNodes5.pagination;

          if (_immediateNodes5 !== null && _immediateNodes5 !== void 0 && (_immediateNodes5$pagi = _immediateNodes5.pagination) !== null && _immediateNodes5$pagi !== void 0 && _immediateNodes5$pagi.next) {
            pageToken = (0, _commonUtils.getQueryParamsFromUrl)(_immediateNodes5 === null || _immediateNodes5 === void 0 ? void 0 : (_immediateNodes5$pagi2 = _immediateNodes5.pagination) === null || _immediateNodes5$pagi2 === void 0 ? void 0 : _immediateNodes5$pagi2.next, _commonConstants.PAGE_TOKEN);
          } else {
            pageToken = '';
          }

          _context2.next = 18;
          break;

        case 27:
          immediateNodes = allResult;
          _context2.next = 30;
          return (0, _effects.put)((0, _action3.successGetImmediateNodes)(immediateNodes, immediateNodesPagination));

        case 30:
          _context2.next = 32;
          return (0, _effects.put)((0, _action2.initSpinnerOverlay)({
            open: false,
            size: 'medium'
          }));

        case 32:
          _context2.next = 44;
          break;

        case 34:
          _context2.prev = 34;
          _context2.t0 = _context2["catch"](1);
          response = _context2.t0.response;
          reason = (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.message) || '';
          _context2.next = 40;
          return (0, _effects.put)((0, _action.openNotification)(_commonConstants.errorNotificationType, reason, true, _commonConstants.errorNotificationDuration));

        case 40:
          _context2.next = 42;
          return (0, _effects.put)((0, _action3.failureGetImmediateNodes)(reason));

        case 42:
          _context2.next = 44;
          return (0, _effects.put)((0, _action2.initSpinnerOverlay)({
            open: false,
            size: 'medium'
          }));

        case 44:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 34]]);
}

var _default = (0, _effects.all)([(0, _effects.fork)(getImmediateNodesWatcher)]);

exports.default = _default;